import http from '@/api/http'
import { protectedRequest } from '@/api/protectedRequest'
import { API_BASE_URL } from '@/config/env'
import {
  mapRestaurantProduct,
  mapRestaurantProductList,
} from '@/entities/restaurant/model/mapRestaurantProduct'

export const RESTAURANT_PRODUCTS_PAGE_SIZE = 5
export const UNCATEGORIZED_CATEGORY_ID = '__uncategorized__'

function hasRestaurantCatalogApi() {
  return Boolean(API_BASE_URL)
}

function unwrapProductList(body) {
  const list = body?.data
  const total = Number(body?.total)
  return {
    items: Array.isArray(list) ? list : [],
    total: Number.isFinite(total) ? total : Array.isArray(list) ? list.length : 0,
  }
}

function buildCategoryFilter(categoryId) {
  if (categoryId === UNCATEGORIZED_CATEGORY_ID) {
    return { category_id: null }
  }
  const id = String(categoryId ?? '').trim()
  if (!id) {
    return null
  }
  return { category_id: id }
}

export async function fetchRestaurantProductsApi({
  categoryId,
  limit = RESTAURANT_PRODUCTS_PAGE_SIZE,
  skip = 0,
  sort = { created_at: -1 },
} = {}) {
  const filter = buildCategoryFilter(categoryId)
  if (!hasRestaurantCatalogApi() || !filter) {
    return { items: [], total: 0 }
  }

  const body = await protectedRequest(() =>
    http.post('/restaurant/products', {
      limit: Math.max(1, Number(limit) || RESTAURANT_PRODUCTS_PAGE_SIZE),
      skip: Math.max(0, Number(skip) || 0),
      filter,
      sort,
    }),
  )

  const { items, total } = unwrapProductList(body)
  return {
    items: mapRestaurantProductList(items),
    total,
  }
}

export async function createRestaurantProductApi(payload) {
  if (!hasRestaurantCatalogApi()) {
    return null
  }

  const body = await protectedRequest(() => http.post('/restaurant/product', payload))
  return mapRestaurantProduct(body?.data ?? body)
}

export async function fetchRestaurantProductByIdApi(productId) {
  if (!hasRestaurantCatalogApi() || !productId) {
    return null
  }

  const body = await protectedRequest(() => http.get(`/restaurant/product/${productId}`))
  return mapRestaurantProduct(body?.data ?? body)
}

export async function updateRestaurantProductApi(productId, patch) {
  if (!hasRestaurantCatalogApi() || !productId) {
    return null
  }

  const body = await protectedRequest(() =>
    http.post(`/restaurant/product/${productId}/update`, patch),
  )
  return mapRestaurantProduct(body?.data ?? body)
}

export async function deleteRestaurantProductApi(productId) {
  if (!hasRestaurantCatalogApi() || !productId) {
    return null
  }

  await protectedRequest(() => http.post(`/restaurant/product/${productId}/delete`, {}))
  return String(productId)
}
